import type { AnnotationManager } from '@atlaskit/editor-common/annotation';
import type {
	InlineCommentCompoundExperience,
	SelectInlineCommentCompoundExperience,
	AnnotationPluginOptions,
	InlineCommentAnnotationProvider,
} from '@atlaskit/editor-plugin-annotation';
import { fg } from '@atlaskit/platform-feature-flags';

interface Props {
	options: {
		annotationManager: AnnotationManager | undefined;
		createCommentExperience: InlineCommentCompoundExperience | undefined;
		selectCommentExperience:
			| Pick<SelectInlineCommentCompoundExperience, 'selectAnnotation'>
			| undefined;
	};
	providers: { inlineCommentAnnotationProvider?: InlineCommentAnnotationProvider };
}

export function annotationPluginOptions({
	options,
	providers,
}: Props): AnnotationPluginOptions | undefined {
	if (!providers.inlineCommentAnnotationProvider) {
		return undefined;
	}

	return {
		createCommentExperience: options.createCommentExperience,
		inlineComment: providers.inlineCommentAnnotationProvider,
		selectCommentExperience: fg('confluence_comments_select_comment_experience')
			? {
					selectAnnotation: {
						complete: (annotationId: string) => {
							options.selectCommentExperience?.selectAnnotation.complete({
								pageClass: 'editor',
								annotationId,
								entryPoint: 'annotation-change',
							});
						},
					},
				}
			: undefined,
		annotationManager: fg('platform_editor_comments_api_manager')
			? options.annotationManager
			: undefined,
	};
}
